import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Headline = styled.div`
  text-align: center;
  font-weight: 300;
  padding: 0 10px;
  color: ${({ theme }) => (theme.chatLayout ? theme.onSecondaryColor : theme.onLightColor)};
`;
